export enum ACCOUNT_FIELDS {
  oldPassword = 'old_password',
  newPassword = 'new_password',
  confirmNewPassword = 'confirm_new_password',
}
